var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___RFpDbl",
  "gs": "ChannelMessages.module__scrollerContainer___RFpDbl",
  "aE": "ChannelMessages.module__bottomFade___RFpDbl",
  "yY": "ChannelMessages.module__bottomFadeStatusAtBottom___RFpDbl",
  "K9": "ChannelMessages.module__bottomFadeStatusScrolled___RFpDbl",
  "gT": "ChannelMessages.module__scrollerContent___RFpDbl",
  "lB": "ChannelMessages.module__scrollerSpacer___RFpDbl",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___RFpDbl",
  "pi": "ChannelMessages.module__fillerBuffer___RFpDbl",
  "CU": "ChannelMessages.module__groupSpacer___RFpDbl",
  "$P": "ChannelMessages.module__groupSpacerHalf___RFpDbl",
  "bv": "ChannelMessages.module__scrollerInner___RFpDbl",
  "eb": "ChannelMessages.module__newMessagesBar___RFpDbl",
  "mC": "ChannelMessages.module__newMessagesBarBanner___RFpDbl",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___RFpDbl",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___RFpDbl",
  "G6": "ChannelMessages.module__messageBottomPill___RFpDbl",
  "Sg": "ChannelMessages.module__jumpToPresentBar___RFpDbl",
  "RQ": "ChannelMessages.module__newMessagesBarText___RFpDbl",
  "As": "ChannelMessages.module__loadErrorBar___RFpDbl",
  "Ku": "ChannelMessages.module__newMessagesBarAction___RFpDbl",
  "WB": "ChannelMessages.module__unreadSlot___RFpDbl",
};

module.exports = exports;
